const translationKeys = {
  overview_greeting_night: 'overview_greeting_night',
  overview_greeting_morning: 'overview_greeting_morning',
  overview_greeting_beforenoon: 'overview_greeting_beforenoon',
  overview_greeting_afternoon: 'overview_greeting_afternoon',
  overview_greeting_evening: 'overview_greeting_evening',
  overview_header_transfer_button: 'overview_header_transfer_button',
  overview_accounts_title: 'overview_accounts_title',
  overview_accounts_subtitle: 'overview_accounts_subtitle',
  overview_accounts_loading_error: 'overview_accounts_loading_error',
  overview_balances_loading_error_short:
    'overview_balances_loading_error_short',
  overview_loans_title: 'overview_loans_title',
  overview_loans_subtitle: 'overview_loans_subtitle',
  overview_loans_loading_error: 'overview_loans_loading_error',
  overview_loans_go_to_loans_and_credit:
    'overview_loans_go_to_loans_and_credit',
  overview_accounts_reorganise_accounts:
    'overview_accounts_reorganise_accounts',
  overview_reorganise_accounts_title: 'overview_reorganise_accounts_title',
  overview_reorganise_accounts_subtitle:
    'overview_reorganise_accounts_subtitle',
  overview_reorganise_accounts_show_account_button_title:
    'overview_reorganise_accounts_show_account_button_title',
  overview_reorganise_accounts_divider_text:
    'overview_reorganise_accounts_divider_text',
  overview_accounts_reorder_accounts: 'overview_accounts_reorder_accounts',
  overview_pension_title: 'overview_pension_title',
  overview_pension_go_to_savings_and_investments:
    'overview_pension_go_to_savings_and_investments',
  overview_pension_subtitle: 'overview_pension_subtitle',
  overview_accounts_go_to_accounts: 'overview_accounts_go_to_accounts',
  overview_header_pay_button: 'overview_header_pay_button',
  overview_insurances_title: 'overview_insurances_title',
  overview_insurances_go_to_insurances: 'overview_insurances_go_to_insurances',
  overview_accounts_reorder_accounts_save_button:
    'overview_accounts_reorder_accounts_save_button',
  overview_insurances_loading_error_title:
    'overview_insurances_loading_error_title',
  overview_insurances_loading_error_message:
    'overview_insurances_loading_error_message',
  overview_insurances_loading_error_reload_button:
    'overview_insurances_loading_error_reload_button',
  overview_loans_loading_error_title: 'overview_loans_loading_error_title',
  overview_loans_loading_error_message: 'overview_loans_loading_error_message',
  overview_loans_loading_error_reload_button:
    'overview_loans_loading_error_reload_button',
  overview_pension_loading_error_title: 'overview_pension_loading_error_title',
  overview_pension_loading_error_message:
    'overview_pension_loading_error_message',
  overview_pension_loading_error_reload_button:
    'overview_pension_loading_error_reload_button',
  overview_accounts_loading_error_title:
    'overview_accounts_loading_error_title',
  overview_accounts_loading_error_message:
    'overview_accounts_loading_error_message',
  overview_accounts_loading_error_reload_button:
    'overview_accounts_loading_error_reload_button',
};

Object.freeze(translationKeys);

export default translationKeys;
